import React, { useCallback } from "react";
import { PickerItem } from "@my-dld/components/Picker";
import { getLocalValue } from "@eres/core/dist/LocaleValue";

export function BaseLoginScreen( props: React.PropsWithChildren<{ containerClass?: string }> ) {
    const { children, containerClass = "auth-container" } = props;
	return <div className={ containerClass }>
		{ children }
	</div>;
}

export function BaseLoginCard( props: React.PropsWithChildren<{ id?: string; extraClasses?: string }> ) {
	const { children, extraClasses, id } = props;
	const cls = extraClasses ? "auth-container-inner " + extraClasses : "auth-container-inner";
	return <div className={ cls } id={ props.id }>
		{ children }
	</div>;
}


export function LoginOptions( props: { items: PickerItem[]; onChange: ( id: string ) => void; checkedId: string } ) {
	let { items, onChange, checkedId } = props;
	const onChangeX = useCallback( ( e: React.ChangeEvent<HTMLInputElement> ) => {
		if ( e.target.checked ) {
			let id = e.target.id;
			id = id.replace( /^(login-opt-)/, "" );
			onChange( id );
		}
	}, [ onChange ] );
	return <div className="chose-signin-option mb-3">
		{ items.map( ( value, index ) => {
			const isChecked = value.id === checkedId;
			return <div className="form-check form-check-inline" key={ value.id }>
				<input
					onChange={ onChangeX }
					className="form-check-input"
					type="radio"
					checked={ isChecked }
					name="inlineRadioOptions"
					id={ `login-opt-${ value.id }` }
					value="option1"/>
				<label
					className="form-check-label"
					htmlFor={ `login-opt-${ value.id }` }>{ getLocalValue( value.value ) }</label>
			</div>;
		} ) }
	</div>;
}
